"use client";

import { useChecklistRealtimeCache } from "@/hooks/use-checklist-realtime-cache";
import { useEventRangeRealtimeSync } from "@/hooks/use-event-range-realtime-sync";
import { useFormSubmissionRealtimeCache } from "@/hooks/use-form-submission-realtime-cache";
import { useFullscriptRealtimeCache } from "@/hooks/use-fullscript-realtime-cache";
import { useLabRealtimeCache } from "@/hooks/use-lab-realtime-cache";
import { useNoteTemplateRealtimeCache } from "@/hooks/use-note-template-realtime-cache";
import { usePatientRealtimeCache } from "@/hooks/use-patient-realtime-cache";
import { useWaitlistRealtimeCache } from "@/hooks/use-waitlist-realtime-cache";

/** Console-wide, non-visual websocket subscribers that maintain query caches. */
export function ConsoleRealtimeCacheSubscribers() {
  useChecklistRealtimeCache();
  useEventRangeRealtimeSync();
  useFormSubmissionRealtimeCache();
  usePatientRealtimeCache();
  useLabRealtimeCache();
  useFullscriptRealtimeCache();
  useNoteTemplateRealtimeCache();
  useWaitlistRealtimeCache();
  return null;
}